/* eslint-disable */
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { useModal } from "../../../../utils/ModalContext";

import { serializeError } from "eth-rpc-errors";

import { Slider, SliderItem } from "../../../../common/slider/Slider";
import Button from "../../../../common/button";
import Particle from "./Particles";
import MintStyleWrapper from "./Mint.style";
import LAND_ABI from "../../../../abi/LANDRegistry.json";
import ERC20_ABI from "../../../../abi/ERC20.json";
import CandyMachine_ABI from "../../../../abi/CandyMachine.json";
import Block_ABI from "../../../../abi/Block.json";
import thumb1 from "../../../../assets/images/nft/land-plot1.jpg";
import thumb2 from "../../../../assets/images/nft/land-plot2.jpg";
import thumb3 from "../../../../assets/images/nft/land-plot3.jpg";
import thumb4 from "../../../../assets/images/nft/land-plot4.jpg";
import checkIcon from "../../../../assets/images/icon/mint-right-text-icon.svg";
import discordIcon from "../../../../assets/images/icon/dis_logo.svg";
import USDCIcon from "../../../../assets/images/icon/usdc_logo.svg";
import USDTIcon from "../../../../assets/images/icon/usdt_logo.svg";
import XIcon from "../../../../assets/images/icon/X_logo.svg";
import { isWalletConnected } from "../../../../lib/metamaskhandler";
import {
  CANDY_MACHINE,
  BLOCK_REGISTRY,
  PRICE,
  USDC_REGISTRY,
  USDT_REGISTRY,
  USDT_TOKEN_INDEX,
  USDC_TOKEN_INDEX,
  MIN_GAS_LIMIT,
  MAX_GAS_LIMIT,
  SURPLUS,
} from "../../../../utils/constants";
import PopupLoader from "../../popupLoader";
import PopupConnect from "../../popupConnect";
import PopupError from "../../popupError";
import MintNowModal from "../../../../common/modal/mintNowModal";
import NetworkModal from "../../../../common/modal/networkModal/NetworkModal";

const Mint = () => {
  const [count, setCount] = useState(1);
  const [error, setError] = useState(" ");
  const [logs, setLogs] = useState({});
  const [inputValue, setInputValue] = useState("1");
  const [paymentIndex, setPaymentIndex] = useState(USDC_TOKEN_INDEX);
  const [tokenName, setTokenName] = useState("USDC");

  const {
    mintModalHandle,
    isPopup,
    setPopup,
    isPopupMetamask,
    isPopupError,

    popupErrorHandle,
    popupHandle,
    popupMetamaskHandle,
    visibility,
    totalSupply,
  } = useModal();

  //console.log("isWalletConnected: ", isWalletConnected());

  const handleMint = async () => {
    // if (!isWalletConnected()) {
    //   popupMetamaskHandle();
    // }
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(
        window.ethereum,
        "any"
      );
      const signer = provider.getSigner();

      const USDCContractInstance = new ethers.Contract(
        USDC_REGISTRY,
        ERC20_ABI,
        signer
      );
      const USDTContractInstance = new ethers.Contract(
        USDT_REGISTRY,
        ERC20_ABI,
        signer
      );
      const contractCandyMachine = new ethers.Contract(
        CANDY_MACHINE,
        CandyMachine_ABI,
        signer
      );

      if (!isWalletConnected()) {
        popupMetamaskHandle();
      } else {
        try {
          if (
            paymentIndex == USDC_TOKEN_INDEX ||
            paymentIndex == USDT_TOKEN_INDEX
          ) {
            console.log("paymentIndex", paymentIndex);
            console.log("tokenName", tokenName);

            let allowanceTx3;

            if (paymentIndex == USDT_TOKEN_INDEX) {
              allowanceTx3 = await USDTContractInstance.allowance(
                await signer.getAddress(),
                contractCandyMachine.address
              );
              console.log("allowanceTx3: ", allowanceTx3);
            } else if (paymentIndex == USDC_TOKEN_INDEX) {
              allowanceTx3 = await USDCContractInstance.allowance(
                await signer.getAddress(),
                contractCandyMachine.address
              );
              console.log("allowanceTx3: ", allowanceTx3);
            }

            if (
              allowanceTx3 >=
              (
                ethers.utils.parseEther(PRICE.toString()) * inputValue
              ).toString()
            ) {
              const getGasLimit = async () => {
                let gasLimit =
                  await contractCandyMachine.estimateGas.reclaimMultipleLand(
                    inputValue,
                    paymentIndex
                  );

                let newGasLimit = gasLimit.toNumber() + inputValue * SURPLUS;
                console.log("newGasLimit: ", newGasLimit);

                if (newGasLimit < MIN_GAS_LIMIT) {
                  return MIN_GAS_LIMIT;
                } else if (newGasLimit > MAX_GAS_LIMIT) {
                  return MAX_GAS_LIMIT;
                } else {
                  return newGasLimit;
                }
              };

              console.log("ReclaimMultipleLand", paymentIndex);

              const reclaimMultipleLand =
                await contractCandyMachine.reclaimMultipleLand(
                  inputValue,
                  paymentIndex,
                  {
                    gasLimit: await getGasLimit(),
                  }
                );

              if (reclaimMultipleLand.confirmations == 0) {
                setPopup(true);
                console.log("Pending...");
              }

              const ReclaimTx = await reclaimMultipleLand.wait();

              setLogs(await reclaimMultipleLand.wait());

              console.log("ReclaimTx ", ReclaimTx);

              if (logs.confirmations != 0) {
                setPopup(false);
                mintModalHandle();
              }
            } else {
              let increaseAllowance, increaseAllowanceTx;

              if (paymentIndex == USDT_TOKEN_INDEX) {
                increaseAllowance =
                  await USDTContractInstance.increaseAllowance(
                    contractCandyMachine.address,
                    (
                      ethers.utils.parseEther(PRICE.toString()) *
                      inputValue.toString()
                    ).toLocaleString("fullwide", { useGrouping: false })
                  );

                if (increaseAllowance.confirmations == 0) {
                  console.log("Pending...");
                  setPopup(true);
                }

                console.log(increaseAllowance);

                increaseAllowanceTx = await increaseAllowance.wait();
              } else if (paymentIndex == USDC_TOKEN_INDEX) {
                increaseAllowance =
                  await USDCContractInstance.increaseAllowance(
                    contractCandyMachine.address,
                    (
                      ethers.utils.parseEther(PRICE.toString()) *
                      inputValue.toString()
                    ).toLocaleString("fullwide", { useGrouping: false })
                  );

                if (increaseAllowance.confirmations == 0) {
                  console.log("Pending...");
                  setPopup(true);
                }

                console.log(increaseAllowance);

                increaseAllowanceTx = await increaseAllowance.wait();
              }

              if (increaseAllowanceTx) {
                setPopup(false);
              }

              // console.log("increaseAllowance done");

              const getGasLimit = async () => {
                let gasLimit =
                  await contractCandyMachine.estimateGas.reclaimMultipleLand(
                    inputValue,
                    paymentIndex
                  );

                let newGasLimit = gasLimit.toNumber() + inputValue * SURPLUS;
                console.log("newGasLimit: ", newGasLimit);

                if (newGasLimit < MIN_GAS_LIMIT) {
                  return MIN_GAS_LIMIT;
                } else if (newGasLimit > MAX_GAS_LIMIT) {
                  return MAX_GAS_LIMIT;
                } else {
                  return newGasLimit;
                }
              };

              const reclaimMultipleLand =
                await contractCandyMachine.reclaimMultipleLand(
                  inputValue,
                  paymentIndex,
                  {
                    gasLimit: await getGasLimit(),
                  }
                );

              if (reclaimMultipleLand.confirmations == 0) {
                console.log("Pending...");
                setPopup(true);
              }

              const ReclaimTx = await reclaimMultipleLand.wait();

              console.log(ReclaimTx);

              setLogs(await reclaimMultipleLand.wait());

              if (logs.confirmations != 0) {
                setPopup(false);
                mintModalHandle();
                console.log(`Reclaimed ${inputValue} lands`);
              }
            }
          }
        } catch (err) {
          console.log("ERROR: ", err);
          setPopup(false);
          errorNotification(err);
        }
      }
    }
  };

  const slideImages = [thumb1, thumb2, thumb3, thumb4];

  const sliderSettings = {
    dots: false,
    arrows: false,
    autoplay: true,
    speed: 50,
    fade: true,
    autoplaySpeed: 500,
    centerMode: true,
    centerPadding: "0px",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const errorNotification = (errorMessage) => {
    const serializedError = serializeError(errorMessage);
    const error = serializedError.data.originalError.reason;
    setError(error.replace("execution reverted: ", ""));

    popupErrorHandle();
  };

  function handleInputChange(event) {
    const value = event.target.value;

    // Remove any non-digit characters
    const digitsOnly = value.replace(/[^0-9]/g, "");

    // Limit the value to be between 1 and 36
    const boundedValue = Math.min(Math.max(digitsOnly, 1), 36);

    // If the input is empty, clear the state
    if (value === "") {
      setInputValue("");
    } else {
      setInputValue(boundedValue);
    }
  }

  function handleIncrement() {
    const newValue = parseInt(inputValue) + 1;
    if (newValue <= 36) {
      setInputValue(newValue.toString());
    }
  }

  function handleDecrement() {
    const newValue = parseInt(inputValue) - 1;
    if (newValue >= 1) {
      setInputValue(newValue.toString());
    }
  }

  const isInputValid = inputValue !== "" && inputValue >= 1 && inputValue <= 36;

  useEffect(() => {
    console.log(inputValue);
  }, [inputValue]);

  const handleDiscordClick = () => {
    window.open("https://discord.gg/coderblock", "_blank");
  };

  const handleTwitterClick = () => {
    window.open("https://twitter.com/coderblock", "_blank");
  };

  const handleButtonClick = () => {
    // Aggiungi qui l'URL a cui desideri reindirizzare
    const redirectUrl = "/wizard";
    window.location.href = redirectUrl;
  };

  const handlePaymentToken = (token) => {
    if (token === "USDC") {
      setPaymentIndex(USDC_TOKEN_INDEX);
    } else if (token === "USDT") {
      setPaymentIndex(USDT_TOKEN_INDEX);
    } else {
      setPaymentIndex(USDC_TOKEN_INDEX);
    }

    setTokenName(token);
  };

  return (
    <MintStyleWrapper>
      <Particle />
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="mint_left_content">
              <div className="mint_left_inner">
                <div className="mint_slider">
                  <Slider {...sliderSettings}>
                    {slideImages?.map((thumb, idx) => (
                      <SliderItem key={idx}>
                        <div className="mb-3">
                          <img src={thumb} alt="thumb" />
                        </div>
                      </SliderItem>
                    ))}
                  </Slider>
                </div>
                {/* <ul className="mint_count_list">
                  <li className="token-btn">
                    <Button
                      lg
                      variant={
                        tokenName == "USDC" ? "outline-active" : "outline"
                      }
                      onClick={() => handlePaymentToken("USDC")}
                    >
                      <img src={USDCIcon} alt="icon" />
                      USDC
                    </Button>
                    <Button
                      lg
                      variant={
                        tokenName == "USDT" ? "outline-active" : "outline"
                      }
                      onClick={() => handlePaymentToken("USDT")}
                    >
                      <img src={USDTIcon} alt="icon" />
                      USDT
                    </Button>
                  </li>
                  <li className="list-item">
                    <h5>Already minted</h5>
                    <h5>{totalSupply > 0 ? totalSupply : "N/A"}</h5>
                  </li>
                  <li className="list-item">
                    <h5>Price</h5>
                    <h5>
                      {PRICE} {tokenName}
                    </h5>
                  </li>
                  <li className="list-item">
                    <h5>Quantity</h5>
                    <div className="mint_quantity_sect">
                      <button
                        className="input_number_decrement"
                        onClick={() => handleDecrement()}
                      >
                        -
                      </button>
                      <input
                        className="input_number"
                        type="text"
                        value={inputValue}
                        onInput={handleInputChange}
                      />
                      <button
                        className="input_number_increment"
                        onClick={() => handleIncrement()}
                      >
                        +
                      </button>
                    </div>
                    <h5>
                      <span>{PRICE * inputValue}</span> {tokenName}
                    </h5>
                  </li>
                </ul> */}
                {/* <Button
                  lg
                  variant={isInputValid ? "mint" : "mint-disabled"}
                  disabled={!isInputValid}
                  onClick={() => handleMint()}
                >
                  {" "}
                  Mint now
                </Button> */}
                <Button lg variant={"mint"} onClick={handleButtonClick}>
                  Buy Now
                </Button>
                <p>
                  By clicking “<strong>BUY NOW</strong>”, you agree to our{" "}
                  <a href="https://coderblock.com/toc-metaverse">
                    Terms of Service
                  </a>{" "}
                  and our{" "}
                  <a
                    className="link-policy"
                    href="https://coderblock.com/policies/privacy-metaverse"
                  >
                    Privacy Policy.{" "}
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="mint_right_content">
              <div className="content_header">
                <div className="content_text">
                  <h5>YOUR FIRST STEPS:</h5>
                </div>
                <div className="content_text">
                  <span>
                    <img src={checkIcon} alt="icon" />
                  </span>
                  <h4>1. Choose your plots from the map</h4>
                </div>
                <div className="content_text">
                  <span>
                    <img src={checkIcon} alt="icon" />
                  </span>
                  <h4>2. Buy with credit card or crypto ⁣⁣</h4>
                </div>
                <div className="content_text">
                  <span>
                    <img src={checkIcon} alt="icon" />
                  </span>
                  <h4>3. Become a Metaverse Creator and earn</h4>
                </div>

                <h1>SEASON 1 LIVE</h1>
              </div>
              <div className="mint_body">
                <p className="font-general leading-5 text-white text-left">
                  {" "}
                  A new universe is about to be born. Become a creator and <span className="body_text_color">start your own story</span>.
                  <br />
                  <br />
                  <h5 className="" style={{fontSize: "17px"}}>GET READY FOR THE NEXT BIG THINGS:</h5>
                  <li>
                    <span className="body_text_color">Creator Marketplace</span>
                    : match with our partner companies and make profits from
                    your sponsored experiences.{" "}                  
                  </li>
                  <li>
                    {" "}
                    <span className="body_text_color">Coderblock ADS</span>:
                    become a Publisher and earn a monthly revenue based on your
                    visitors.
                  </li>
                  <br />
                  {/* <span className="body_text_color"> estate</span>. */}
                </p>
                <p className="font-general leading-5 text-white text-left">
                  New portion of the map around{" "}
                  <span className="body_text_color"> Hexagon</span>: the main
                  city of <span className="body_text_color"> Coderblock Universe</span>, which will play a key role in the
                  upcoming official game (more info <a href="https://path-of-the-hero.coderblock.com" className="body_text_color" target="_blank">available here</a>).
                </p>
                <p className="font-general text-white text-left">
                  Get ready for your adventure!
                </p>
              </div>
              <div className="mint_btns">
                <Button
                  lg
                  variant="outline"
                  onClick={() => handleDiscordClick()}
                >
                  <img src={discordIcon} alt="icon" />
                  join discord
                </Button>
                <Button
                  lg
                  variant="outline"
                  onClick={() => handleTwitterClick()}
                >
                  <img src={XIcon} alt="icon" />
                  join X
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {visibility && <MintNowModal logs={logs} />}
      {isPopup && (
        <div className="popUp_container">
          <PopupLoader popupHandle={popupHandle} />
        </div>
      )}
      {isPopupMetamask && (
        <div className="popUp_container">
          <PopupConnect popupHandle={popupMetamaskHandle} />
        </div>
      )}
      {isPopupError && (
        <div className="popUp_container">
          <PopupError popupHandle={popupErrorHandle} error={error} />
        </div>
      )}
    </MintStyleWrapper>
  );
};

export default Mint;
